import React from 'react';
import { motion } from 'framer-motion';
import { SyringeIcon, SparklesIcon, ActivityIcon, ZapIcon, HeartIcon, PenToolIcon, SmileIcon } from 'lucide-react';
export function FeaturedServices() {
  const services = [{
    name: 'Injectables',
    description: 'Refined treatments to enhance and restore natural facial balance.',
    icon: SyringeIcon
  }, {
    name: 'Skin Rejuvenation',
    description: 'Advanced skincare solutions for a refreshed, radiant complexion.',
    icon: SparklesIcon
  }, {
    name: 'Body Contouring',
    description: 'Non-invasive treatments designed to sculpt and refine your silhouette.',
    icon: ActivityIcon
  }, {
    name: 'Lasers',
    description: 'Precision laser treatments for skin clarity and rejuvenation.',
    icon: ZapIcon
  }, {
    name: 'Wellness Treatments',
    description: 'Holistic wellness services to support your overall vitality.',
    icon: HeartIcon
  }, {
    name: 'Permanent Makeup',
    description: 'Subtle, lasting enhancements for effortless everyday beauty.',
    icon: PenToolIcon
  }, {
    name: 'Teeth Whitening',
    description: 'Professional whitening for a brighter, more confident smile.',
    icon: SmileIcon
  }];
  return <section id="treatments" className="py-24 bg-brand-soft-black relative" data-id="element-146">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-147">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-148">
          <h2 className="font-heading text-3xl md:text-4xl text-brand-white mb-4" data-id="element-149">
            Curated Aesthetic Services
          </h2>
          <div className="w-16 h-px bg-brand-gold mx-auto mb-6" data-id="element-150"></div>
          <p className="text-brand-champagne-light/70" data-id="element-151">
            Discover our comprehensive range of treatments, each tailored to
            highlight your natural beauty without compromising safety or
            elegance.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-id="element-152">
          {services.map((service, index) => <motion.div key={service.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-brand-black border border-brand-charcoal p-8 rounded-sm hover:border-brand-gold/40 transition-all duration-300 group flex flex-col h-full" data-id="element-153">
              <service.icon className="w-8 h-8 text-brand-gold mb-6 group-hover:scale-110 transition-transform duration-300" strokeWidth={1} data-id="element-154" />
              <h3 className="font-heading text-xl text-brand-white mb-3" data-id="element-155">
                {service.name}
              </h3>
              <p className="text-brand-champagne-light/60 text-sm leading-relaxed mb-6 flex-grow" data-id="element-156">
                {service.description}
              </p>
              <button onClick={() => document.getElementById('appointment')?.scrollIntoView({
            behavior: 'smooth'
          })} className="text-brand-gold text-sm font-medium uppercase tracking-wider hover:text-brand-gold-light inline-flex items-center mt-auto cursor-pointer bg-transparent border-none p-0" data-id="element-157">
                Book Consultation{' '}
                <span className="ml-2 group-hover:translate-x-1 transition-transform" data-id="element-158">
                  →
                </span>
              </button>
            </motion.div>)}

          {/* CTA Card to fill the grid nicely */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: services.length * 0.1
        }} className="bg-brand-gold border border-brand-gold p-8 rounded-sm flex flex-col justify-center items-center text-center h-full" data-id="element-159">
            <h3 className="font-heading text-xl text-brand-black mb-3" data-id="element-160">
              Not sure where to start?
            </h3>
            <p className="text-brand-black/80 text-sm mb-6" data-id="element-161">
              Schedule a consultation to discuss a personalized treatment plan.
            </p>
            <button onClick={() => document.getElementById('appointment')?.scrollIntoView({
            behavior: 'smooth'
          })} className="px-6 py-2 border border-brand-black text-brand-black text-sm font-medium rounded-sm hover:bg-brand-black hover:text-brand-gold transition-colors duration-300 cursor-pointer bg-transparent" data-id="element-162">
              Book Consultation
            </button>
          </motion.div>
        </div>
      </div>
    </section>;
}